import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../services/api';
import './AlertBanner.css';

interface AlertBannerProps {
  /** If true, the banner will not fetch from the API and will always be hidden. */
  disabled?: boolean;
}

const AlertBanner: React.FC<AlertBannerProps> = ({ disabled = false }) => {
  const [message, setMessage] = useState<string | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (disabled) return;
    adminAPI.getActiveAlert()
      .then((data) => {
        if (data?.alert?.message) {
          setMessage(data.alert.message);
        }
      })
      .catch(() => {
        // Silently ignore — alert banner is non-critical
      });
  }, [disabled]);

  if (!message || dismissed) return null;

  return (
    <div className="alert-banner" role="alert">
      <i className="material-icons alert-banner__icon">warning</i>
      <span className="alert-banner__message">{message}</span>
      <button
        className="alert-banner__dismiss"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss alert"
      >
        <i className="material-icons">close</i>
      </button>
    </div>
  );
};

export default AlertBanner;
